// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paragraph-marging {
  margin: 0 0 30px 0;
}

.text-wrapper,
.checkbox-wrapper {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/add-quick-selection-dialog-component/add-quick-selection-dialog-component.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;;EAEI,mBAAA;AACJ","sourcesContent":[".paragraph-marging {\r\n    margin: 0 0 30px 0;\r\n}\r\n\r\n.text-wrapper,\r\n.checkbox-wrapper {\r\n    margin-bottom: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
